import { updateQueryAndPathParams } from 'email-management-lib/refactor/actions/params';
import { useHistory } from 'react-router-dom';
import { UI_MODE } from 'framework-listing-lib/constants';
import { useDispatch } from 'react-redux';
import { fetchEmails } from 'email-management-lib/refactor/actions/manage/general';
import { useCallback, useMemo } from 'react';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
export default function useEmailUIModeProps() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isUngatedForNewFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const uiMode = history.location.pathname.includes('folder') ? UI_MODE.FOLDERS : UI_MODE.LIST;
  const onChangeUIMode = useCallback((newUIMode = UI_MODE.LIST) => {
    if (newUIMode === UI_MODE.FOLDERS && isUngatedForNewFrameworkFolders) {
      history.push(`/manage/folders`);
      return;
    }
    if (newUIMode === UI_MODE.FOLDERS && !isUngatedForNewFrameworkFolders) {
      dispatch(updateQueryAndPathParams({
        state: null,
        outageFilter: null
      }, {
        state: '',
        folderId: ''
      }, fetchEmails, '/manage/folder'));
      return;
    }
    if (isUngatedForNewFrameworkFolders) {
      history.push(`/manage`);
    }
  }, [dispatch, history, isUngatedForNewFrameworkFolders]);
  const uiModeProps = useMemo(() => ({
    currentUIMode: uiMode,
    onChangeUIMode
  }), [uiMode, onChangeUIMode]);
  return uiModeProps;
}